<template>
  <div :class="[`fw-filterelem-filter`, `fw-filterelem-filter-multi`]">
    <div class="fw-filterelem-filter-content">
      <div
        v-for="option in options"
        :key="option.value"
        class="fw-filterelem-filter-multi-option"
      >
        <PrimeVueButton
          :class="{ active: localValue.includes(option.value) }"
          @click="toggleSelection(option.value)"
        >
          {{ option.label }}
        </PrimeVueButton>
      </div>
    </div>
    <div class="fw-filterelem-filter-actions">
      <PrimeVueButton class="action-save" @click="applyFilter">
        {{ languageStrings.apply[languageStore.language] }}
      </PrimeVueButton>
      <Transition name="filterpel-fade">
        <PrimeVueButton
          v-if="localValue.length > 0"
          class="action-clear p-button-secondary"
          @click="clearFilter"
        >
          {{ languageStrings.reset[languageStore.language] }}
        </PrimeVueButton>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import { default as PrimeVueButton } from 'primevue/button';

import useLanguageStore from "@/stores/language";

// define props & emits
const props = defineProps<{
  modelValue: unknown,
  options: { label: string, value: string }[],
}>();
const emit = defineEmits<{
  "update:modelValue": [value: unknown[] | undefined]
  "applyFilter": [value: unknown[]]
  "clearFilter": []
  "closeDropdown": []
}>();

// define stores
const languageStore = useLanguageStore();

// define language strings
const languageStrings: ILanguageStrings = {
  apply: {
    de: "Anwenden",
    en: "Apply"
  },
  reset: {
    de: "Zurücksetzen",
    en: "Reset"
  }
};

// define value
const localValue = ref<string[]>([]);
watch(() => props.modelValue, (newValue) => {
  localValue.value = Array.isArray(newValue) ? newValue : [];
});

// define options
const options = ref(props.options ?? []);

// toggle selection
const toggleSelection = (value: string) => {
  if (localValue.value.includes(value)) {
    localValue.value = localValue.value.filter(v => v !== value);
  } else {
    localValue.value.push(value);
  }
};

// apply filter
const applyFilter = () => {
  // if empty, clear and close dropdown
  if (localValue.value.length === 0) {
    clearFilter();
    closeDropdown();
    return;
  }

  // else submit new values
  emit("update:modelValue", localValue.value);
  emit("applyFilter", localValue.value);
};

// clear filter
const clearFilter = () => {
  localValue.value = [];
  emit("update:modelValue", undefined);
  emit("clearFilter");
};

// close dropdown
const closeDropdown = () => {
  emit("closeDropdown");
};

</script>
